import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaMedal} from "react-icons/fa6";
import ApprovalRewards from "./index";
import { MODULE_APPROVAL_REWARDS } from "variables/constants";

const approvalRewardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Approval Rewards",
        basePath: "approval-rewards",
        mainComponent: <ApprovalRewards />,
        layout: "/console",	   
        icon: <FaMedal className="icon-item" />,
        subTitle:"Approval Rewards",
        level:5,
        moduleId: MODULE_APPROVAL_REWARDS,
    })
]

export default approvalRewardRoutes;